
import type { PropType } from 'vue'
import { defineComponent, ref } from 'vue'

// > composable <
import useTooltip from '@/modern/composable/useTooltip'
import useClickOutside from '@/modern/composable/useClickOutside'

export default defineComponent({
    props: {
        size: {
            type: String as PropType<'medium' | 'big'>,
            default: 'medium'
        },
        modelValue: {
            type: [String, Number, null] as PropType<string | number | null>,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:modelValue', 'input', 'change', 'focus', 'blur'],
    setup(props, { emit }) {
        const containerReference = ref<HTMLElement | null>(null)

        const onUpdateModelValue = (value: string) => emit('update:modelValue', value)
        const onChange = (value: string) => emit('change', value)
        const onInput = (event: Event) => emit('input', event)

        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'bottom',
            strategy: 'absolute',
            offset: 8,
            autoPlacement: {
                allowedPlacements: ['bottom'],
            },
        })

        useClickOutside(containerReference, close)

        const onFocus = (event: FocusEvent) => {
            open()
            emit('focus', event)
        }

        const onBlur = (event: FocusEvent) => {
            emit('blur', event)
        }

        return {
            containerReference,
            onUpdateModelValue,
            onChange,
            onInput,
            onFocus,
            onBlur,
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
        }
    }
})
